// extracted by mini-css-extract-plugin
module.exports = {"container":"Logout_container__2YMPV","msg":"Logout_msg__Lqgoo","logoutBtn":"Logout_logoutBtn__1fQRl"};